import React from 'react';
import { Box, Typography, IconButton, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { IModalTemplateHeader } from './types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    header: {
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    closeButton: {
        padding: theme.spacing(0.5),
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}));

export const ModalTemplateHeader = ({ onClose }: IModalTemplateHeader) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.header}>
            <Typography component="h2">
                {t('TwilioTemplates.Choose')}
            </Typography>
            <IconButton
                className={classes.closeButton}
                onClick={onClose}
                data-testid="close-modal-button"
                size="small"
            >
                <Close />
            </IconButton>
        </Box>
    );
};
